import { useBookkeepingSettings } from 'modules/bookkeep/apis/useBookkeepingSettings';
import type { Payable } from 'modules/bookkeep/payables/containers/PayablePanelContainer/hooks/usePayableQuery/payable';
import {
  getIsPayableExported,
  type PayableState,
} from 'modules/bookkeep/payables/models/payable';
import { unwrapQuery } from 'src/core/api/unwrapQuery';

import { useIsLockedPayable } from './useIsLockedPayable';
import { useSpanishDprArchived } from './useSpanishDprArchived';

export const useIsEditablePayable = (
  payable?: {
    creationDate: Date;
    state: PayableState;
    accountingDate: Date | undefined;
  } & Pick<Payable, 'documentaryEvidence'>,
): boolean => {
  const bookkeepingSettingsQueryResult = useBookkeepingSettings();
  const bookkeepingSettings = unwrapQuery(bookkeepingSettingsQueryResult);

  const isLockedPayable = useIsLockedPayable(payable);
  const { isArchived: isSpanishDprArchived } = useSpanishDprArchived(payable);

  if (isSpanishDprArchived) {
    return false;
  }

  if (!payable) {
    return false;
  }

  const isPayableExported = getIsPayableExported(payable);

  if (!isPayableExported) {
    return true;
  }

  return !!(
    bookkeepingSettings?.editPayablesAfterExport?.hasOptedIn && !isLockedPayable
  );
};
